// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD6yryrY9ky_VzxGf62dSI2MthTNH-_ur0',
    authDomain: 'mission-24278.firebaseapp.com',
    projectId: 'mission-24278',
    storageBucket: 'mission-24278.appspot.com',
    messagingSenderId: '1057839119898',
    appId: '1:1057839119898:web:17e288d8cb83a8cd1e1ba3',
    measurementId: 'G-MYLM6Y27XH',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
